import { ApplicationView } from '@aha-app/mvc';
import React, { useRef, useState } from 'react';
import { type Instance as TippyInstance } from 'tippy.js/index';
import styles from '../../styles.module.css';
import ToolButton from '../../toolbars/ToolButton';
import { ColorPalette } from '../../tools/ColorSwatch';
import { colorPaletteForText } from '../../utils/DefaultsManager';
import { type ToolButtonComponent } from '../Tool';
import ToolWireframe from './ToolWireframe';

const TextColorButton: ToolButtonComponent = ApplicationView(
  ({ selection, tool }) => {
    const tippyRef = useRef<TippyInstance>();
    const initialColor = selection.firstObject().textColor;
    const [currentColor, setCurrentColorState] = useState(initialColor);

    return (
      <ToolButton
        popup={
          <ColorPalette
            currentColor={currentColor}
            setCurrentColor={textColor => {
              setCurrentColorState(textColor);
              selection.setOnObjects({ textColor });
            }}
            palette={colorPaletteForText()}
            hidePopup={() => tippyRef.current?.hide()}
          />
        }
        tool={tool}
        tippyRef={tippyRef}
      >
        <div className={styles.textToolButton}>
          <aha-icon icon='fa-solid fa-font' />
          <div
            className={styles.textToolButtonSwatch}
            style={{ backgroundColor: currentColor }}
          />
        </div>
      </ToolButton>
    );
  }
);

class ToolWireframeTextColor extends ToolWireframe {
  static toolName = 'Text color';

  static buttonComponent() {
    return TextColorButton;
  }
}

export default ToolWireframeTextColor;
